
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telus/[...slug]",
      function () {
        return require("private-next-pages/telus/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telus/[...slug]"])
      });
    }
  